module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/rock.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n    I write code and music at the University of Maryland.\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//johannmiller.com/resume.pdf"
    }
  }, [_vm._v("resume")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/johannkm"
    }
  }, [_vm._v("github")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/johannkm/"
    }
  }, [_vm._v("linkedin")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73bedad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomePage.vue
// module id = 31
// module chunks = 0